const mediaItems = [
  {
    title: '《星际穿越》深度解读',
    desc: '诺兰科幻巨制的哲学内核与视觉美学',
    tag: '影评精选',
    imgSrc: 'https://readdy.ai/api/search-image?query=A%20cinematic%20deep%20space%20scene%20with%20golden%20warm%20light%2C%20elegant%20minimal%20composition%2C%20film%20analysis%20aesthetic%2C%20dark%20background%20with%20coral%20glow&width=640&height=360&seq=media-interstellar&orientation=landscape',
  },
  {
    title: '悬疑片为什么让人上瘾',
    desc: '从心理学角度解析高分悬疑电影的吸引力法则',
    tag: '观影指南',
    imgSrc: 'https://readdy.ai/api/search-image?query=A%20moody%20dark%20cinematic%20atmosphere%20with%20warm%20amber%20light%20peeking%20through%2C%20mystery%20and%20suspense%20theme%2C%20elegant%20noir%20composition&width=640&height=360&seq=media-mystery&orientation=landscape',
  },
  {
    title: '2024年不可错过的十佳影片',
    desc: '年度高分电影大盘点，每一部都值得反复观看',
    tag: '年度盘点',
    imgSrc: 'https://readdy.ai/api/search-image?query=An%20elegant%20award-style%20composition%20with%20warm%20golden%20lighting%2C%20sophisticated%20film%20festival%20atmosphere%2C%20minimal%20dark%20background%20with%20coral%20accents&width=640&height=360&seq=media-top10&orientation=landscape',
  },
  {
    title: '国产电影的崛起之路',
    desc: '从《霸王别姬》到当下，华语电影的蜕变与突破',
    tag: '深度观察',
    imgSrc: 'https://readdy.ai/api/search-image?query=A%20warm%20artistic%20composition%20with%20traditional%20Chinese%20cultural%20elements%2C%20modern%20cinema%20aesthetic%2C%20elegant%20golden%20and%20crimson%20tones&width=640&height=360&seq=media-chinese&orientation=landscape',
  },
];

export default function MediaSection() {
  return (
    <section id="media" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-3">
            精彩影评
          </h2>
          <p className="text-sm text-foreground-500 max-w-lg mx-auto">
            深度影评与观影指南，帮您发现更多好片背后的故事
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5">
          {mediaItems.slice(0, 4).map((item) => (
            <div
              key={item.title}
              className="bg-background-50 rounded-xl overflow-hidden cursor-pointer group"
            >
              <div className="aspect-video overflow-hidden bg-background-200 relative">
                <img
                  src={item.imgSrc}
                  alt={item.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-300"
                />
                <div className="absolute inset-0 bg-foreground-950/20 group-hover:bg-foreground-950/30 transition-colors flex items-center justify-center">
                  <div className="w-12 h-12 rounded-full bg-primary-500/90 flex items-center justify-center group-hover:bg-primary-500 transition-colors">
                    <i className="ri-play-fill text-background-50 text-lg ml-0.5"></i>
                  </div>
                </div>
              </div>
              <div className="p-4">
                <span className="inline-block px-2.5 py-0.5 rounded-full text-xs font-medium bg-accent-100 text-accent-700 mb-2">
                  {item.tag}
                </span>
                <h3 className="font-heading text-sm font-semibold text-foreground-900 mb-1 group-hover:text-primary-600 transition-colors">
                  {item.title}
                </h3>
                <p className="text-xs text-foreground-500 leading-relaxed">
                  {item.desc}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}